export const diyMain = [
  {
    name: 'diy',
    path: '/diy',
    meta: {
      title: 'DIY页面',
      icon: 'shezhi',
      plugin: 'diy'
    }
  },
  {
    name: 'diyList',
    path: '/diy/list',
    component: () => import('/@/views/plugins/diy/List.vue'),
    meta: { title: '主题管理', plugin: 'diy' }
  },
  {
    name: 'diyArticle',
    path: '/diy/article',
    component: () => import('/@/views/plugins/diy/article/index.vue'),
    meta: { title: '管理文章', plugin: 'diy', noTag: true },
    redirect: '/diy/article/list',
    children: [
      {
        name: 'diyArticleList',
        path: 'list',
        component: () => import('/@/views/plugins/diy/article/list.vue'),
        meta: { title: '管理文章', plugin: 'diy', keepAlive: true }
      },
      {
        name: 'diyArticleCategory',
        path: 'category',
        component: () => import('/@/views/plugins/diy/article/category.vue'),
        meta: { title: '文章分类', plugin: 'diy', keepAlive: true }
      },
      {
        name: 'diyArticleEdit',
        path: 'edit',
        component: () => import('/@/views/plugins/diy/article/edit.vue'),
        meta: { title: '添加文章', plugin: 'diy', keepAlive: false }
      }
    ]
  },
  {
    name: 'diyMessage',
    path: '/diy/message',
    component: () => import('/@/views/plugins/diy/message/index.vue'),
    meta: { title: '留言管理', plugin: 'diy', keepAlive: true }
  }
]

export const diyOpen = [
  {
    name: 'diyHandle',
    path: '/diy/handle',
    component: () => import('/@/views/plugins/diy/Handle.vue'),
    meta: { title: 'DIY页面编辑', plugin: 'diy' }
  },
  {
    name: 'diyTemplateManage',
    path: '/diy/template/manage',
    component: () => import('/@/views/plugins/diy/TemplateManage.vue'),
    meta: { title: '组件模板管理', plugin: 'diy', keepAlive: true }
  },
  {
    name: 'diyPageRender',
    path: '/diy/page/:id',
    component: () => import('/@/views/plugins/diy/PageRender.vue'),
    meta: { title: '页面预览', plugin: 'diy' }
  }
]

